import { render, staticRenderFns } from "./counterpartiesModalDelContact.vue?vue&type=template&id=5c2036f2"
import script from "./counterpartiesModalDelContact.vue?vue&type=script&lang=js"
export * from "./counterpartiesModalDelContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports